import { Card, Col, Collapse, CollapseProps, Row } from 'antd';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

// components
import DisabledElement from 'components/disabledElement/disabledElement';
import Icon from 'utils/icon';

// services

// styles

// models
// import { Heir } from '../models/heir';
import { CollapseItemStyles } from 'utils/styles/collapseItem';
import { Heir } from '../models/heir';

interface HeirsViewerComponentProps {
	heirs: Heir[];
}

const HeirsViewerComponent: FunctionComponent<HeirsViewerComponentProps> = ({ heirs }): JSX.Element => {
	const { t } = useTranslation();

	const heirsCollapseItems: CollapseProps['items'] = heirs.map((heir, index) => {
		return {
			key: index,
			label: `${t('ACTIONS.HEIR')} #${index + 1}`,
			children: (
				<>
					<Row gutter={[16, 16]} className="mb-3">
						<Col span={24} md={12}>
							<DisabledElement fullWidth label={t('COMMON.SHAREHOLDER_FULL_NAME')} value={heir.name} />
						</Col>
						<Col span={24} md={12}>
							<DisabledElement fullWidth label={t('COMMON.NATIONAL_ID')} value={heir.national_id} />
						</Col>
					</Row>

					<Row gutter={[16, 16]} className="mb-3">
						<Col span={24} md={8}>
							<DisabledElement label={t('ACTIONS.FREE_COMMON_SHARES_COUNT')} value={heir.common_shares?.free || '0'} />
						</Col>
						<Col span={24} md={8}>
							<DisabledElement label={t('ACTIONS.SUSPENDED_COMMON_SHARES_COUNT')} value={heir.common_shares?.suspended || '0'} />
						</Col>
						<Col span={24} md={8}>
							<DisabledElement label={t('ACTIONS.MORTGAGED_COMMON_SHARES_COUNT')} value={heir.common_shares?.mortgaged || '0'} />
						</Col>
					</Row>

					{heir.preferred_shares && (
						<Row gutter={[16, 16]}>
							<Col span={24} md={8}>
								<DisabledElement label={t('ACTIONS.FREE_PREFERRED_SHARES_COUNT')} value={heir.preferred_shares?.free || '0'} />
							</Col>
							<Col span={24} md={8}>
								<DisabledElement label={t('ACTIONS.SUSPENDED_PREFERRED_SHARES_COUNT')} value={heir.preferred_shares?.suspended || '0'} />
							</Col>
							<Col span={24} md={8}>
								<DisabledElement label={t('ACTIONS.MORTGAGED_PREFERRED_SHARES_COUNT')} value={heir.preferred_shares?.mortgaged || '0'} />
							</Col>
						</Row>
					)}
				</>
			),
			style: { ...CollapseItemStyles, backgroundColor: '#fff' },
		};
	});

	return (
		<Card className="mt-2">
			<h5 className="mb-3">{t('ACTIONS.NO_OF_HEIRS', { num: heirs?.length || 1 })}</h5>
			<Collapse
				bordered={false}
				expandIconPosition="end"
				style={{ background: 'transparent' }}
				collapsible="icon"
				expandIcon={({ isActive }) => (
					<Icon
						name="rightArrow"
						height={18}
						color="#555"
						style={{ transition: 'all .2s ease-in-out', transform: isActive ? 'rotate(-90deg)' : 'rotate(90deg)' }}
					/>
				)}
				items={heirsCollapseItems}
			/>
		</Card>
	);
};

export default HeirsViewerComponent;
